import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";

//component
import SessionManagement from "./SessionManagement";
import Spinner from "COMPONENTS/Spinner/Spinner";

//Actions
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";
import { callWaitingAction } from "CONFIG/ActionFactory";
import { CONFIG, OPERATOR_STATUS } from "../../Utils/Constants";
import { getTimeInMillisec } from "UTILS/DateUtils";

export class SessionManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state={
      spinnerVisibility: false
    }
  }
  
  componentDidMount() {
    console.log(`timestamp: Landed on Agent Dashboard at ${getTimeInMillisec()}, milliseconds: ${new Date().getTime()}`);
    // to avoid back click on create session 
    history.pushState(null, null, location.href);

    //TODO: check event.state value 
    //TODO: check if we can remove this listener
    
    window.onpopstate = function(event) {
      history.go(1);
    };
  }

  showStartMeeting = () =>{
    this.props.history.push(CONFIG.path.startMeeting)
  }

  showScheduleMeeting = () =>{
    this.props.history.push(CONFIG.path.scheduleMeeting)
  }

  showTrailHistory = () =>{
    this.props.history.push(CONFIG.path.trailHistory)
  }

  showWaitingUsers = () =>{
    this.props.history.push(CONFIG.path.waitingUsers)
  }

  showCallWaiting = () =>{
    callWaitingAction.setOperatorStatus(OPERATOR_STATUS.WAITING);
    this.props.history.push(CONFIG.path.callWaiting)
  }

  render() {
    return (
      <React.Fragment>
        <Spinner showSpinner={this.state.spinnerVisibility} />
        <SessionManagement
          setLanguageAction={this.props.setLanguageAction}
          language={this.props.language}
          showStartMeeting={this.showStartMeeting}
          showScheduleMeeting={this.showScheduleMeeting}
          showTrailHistory={this.showTrailHistory}
          showWaitingUsers={this.showWaitingUsers}
          showCallWaiting={this.showCallWaiting}
          isAvailable={this.props.isAvailable}
          isOperator={this.props.isOperator}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.LanguageReducer.language,
    isAvailable: state.UserReducer.userProfileData.isAvailable,
    //isAvailable: state.UserReducer.userDetails.isAvailable,
    isOperator: state.UserReducer.userProfileData.isOperator,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setLanguageAction
    },
    dispatch
  );
};

export default withErrorHandler(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SessionManagementContainer)
);
